import React from "react";
import PropTypes from "prop-types";
import ReportsTable from "./table";

const ReportListByGroup = ({
  description,
  reportList,
  isAdHoc,
  refreshListCallback,
}) => (
  <>
    <h4>{description}</h4>
    <ReportsTable
      reportList={reportList}
      isAdHoc={isAdHoc}
      refreshListCallback={refreshListCallback}
    />
  </>
);

ReportListByGroup.propTypes = {
  description: PropTypes.string,
  reportList: PropTypes.arrayOf(PropTypes.object),
  isAdHoc: PropTypes.bool,
  refreshListCallback: PropTypes.func.isRequired,
};

ReportListByGroup.defaultProps = {
  isAdHoc: false,
  description: "",
  reportList: [],
};

export default ReportListByGroup;
